module.exports = __WEBPACK_EXTERNAL_MODULE_78__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx"],"commonjs":"rxjs/operator/filter","commonjs2":"rxjs/operator/filter","amd":"rxjs/operator/filter"}
// module id = 78
// module chunks = 0